import React from "react";
import { Link } from "react-router-dom";

import TransparentProductVideo from "./TransparentProductVideo";
import stackedVideo from "../Assest/product_video_rgba_stacked.mp4"; // replace with your actual video path


import { motion } from "framer-motion";

const Hero = () => {
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 25,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };



  return (
    <section style={styles.hero}>

      {/* Small brand label */}
      <motion.div
        style={styles.eyebrow}
        variants={fadeUp}
        initial="hidden"
        animate="visible"
      >
        CLUSTERCLEAR
      </motion.div>

      {/* Main headline */}
      <motion.h1
        style={styles.title}
        variants={fadeUp}
        initial="hidden"
        animate="visible"
        transition={{
          duration: 0.9,
          delay: 0.12,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        Your business.
        <br />
        <span style={styles.titleLight}>On your wrist.</span>
      </motion.h1>

      {/* Explanation */}
      <motion.p
        style={styles.subtitle}
        variants={fadeUp}
        initial="hidden"
        animate="visible"
        transition={{
          duration: 0.8,
          delay: 0.28,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        Tap to instantly share your business, socials and contact details.
        <br />
        Already on the wrists of business owners, creators and professionals.
      </motion.p>

      {/* Buttons */}
      <motion.div
        style={styles.buttons}
        variants={fadeUp}
        initial="hidden"
        animate="visible"
        transition={{
          duration: 0.8,
          delay: 0.4,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        <Link to="/product" style={styles.primaryLink}>
          Get your wristband
        </Link>

        <Link
          to="https://www.instagram.com/reel/DcL5zi4sjLx/?igsi=ZHR3MW5xM2I2OWxi"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.secondaryLink}
        >
          See how it works
          <span style={styles.arrow}>→</span>
        </Link>
      </motion.div>

      {/* Wristband */}
      <motion.div
        style={styles.productContainer}
        initial={{
          opacity: 0,
          y: 60,
          scale: 0.92,
        }}
        animate={{
          opacity: 1,
          y: 0,
          scale: 1,
        }}
        transition={{
          duration: 1.2,
          delay: 0.5,
          ease: [0.16, 1, 0.3, 1],
        }}
      >
        <motion.div
          animate={{
            y: [0, -8, 0],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          style={styles.productInner}
        >
          <TransparentProductVideo
            src={stackedVideo}
            style={styles.productVideo}
          />
        </motion.div>
      </motion.div>

      {/* Features */}
      <motion.div
        style={styles.features}
        initial={{
          opacity: 0,
          y: 20,
        }}
        animate={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 0.8,
          delay: 0.9,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        <div style={styles.feature}>
          <strong>No charging</strong>
          <span>No battery required</span>
        </div>

        <div style={styles.feature}>
          <strong>Water-resistant</strong>
          <span>Made for everyday wear</span>
        </div>

        <div style={styles.feature}>
          <strong>One simple tap</strong>
          <span>Share everything</span>
        </div>
      </motion.div>
    </section>
  );
};
const styles = {
  hero: {
    minHeight: "100vh",
    width: "100%",
    background: "#ffffff",
    color: "#111111",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    paddingTop: "110px",
    paddingBottom: "60px",
    overflow: "hidden",
  },

  eyebrow: {
    fontSize: "12px",
    letterSpacing: "0.18em",
    fontWeight: "600",
    color: "#777777",
    marginBottom: "28px",
  },

  title: {
    margin: 0,
    fontSize: "clamp(3.5rem, 8vw, 7.5rem)",
    lineHeight: "0.98",
    letterSpacing: "-0.065em",
    fontWeight: "700",
  },

  titleLight: {
    color: "#777777",
    fontWeight: "600",
  },

  subtitle: {
    maxWidth: "650px",
    marginTop: "30px",
    marginBottom: 0,
    fontSize: "clamp(1rem, 1.7vw, 1.2rem)",
    lineHeight: "1.6",
    color: "#666666",
    padding: "0 20px",
  },

  buttons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "24px",
    marginTop: "32px",
    flexWrap: "wrap",
  },

  primaryLink: {
    background: "#6355ff",
    color: "#ffffff",
    padding: "14px 25px",
    borderRadius: "999px",
    textDecoration: "none",
    fontSize: "15px",
    fontWeight: "600",
    transition: "transform 0.2s ease",
  },

  secondaryLink: {
    color: "#111111",
    textDecoration: "none",
    fontSize: "15px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "7px",
  },

  arrow: {
    fontSize: "18px",
    transition: "transform 0.2s ease",
  },

  /*
    This is where the 3D wristband becomes
    the visual focus of the hero.
  */
  productContainer: {
    width: "450px",
    maxWidth: "1000px",
    height: "40%",
    marginTop: "55px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    background: "transparent",
      aspectRatio: "1 / 1",
  },

  productVideo: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
  },

  /*
    Small trust/product information underneath
  */
  features: {
    width: "100%",
    maxWidth: "850px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "1px solid #eeeeee",
    paddingTop: "25px",
    marginTop: "15px",
    paddingLeft: "20px",
    paddingRight: "20px",
    gap: "30px",
  },

  feature: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    flex: 1,
  },

  /*
    Mobile
  */
  "@media (max-width: 700px)": {
    hero: {
      paddingTop: "80px",
    },

    title: {
      fontSize: "clamp(3rem, 15vw, 5rem)",
    },

    subtitle: {
      fontSize: "1rem",
    },

    productContainer: {
      height: "320px",
      marginTop: "40px",
    },

    features: {
      flexDirection: "column",
      gap: "20px",
    },

    feature: {
      width: "100%",
    },
  },
};

export default Hero;